import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useEffect, useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import WelcomePage from "./pages/WelcomePage";
import Dashboard from "./pages/Dashboard";
import AIGenerate from "./pages/AIGenerate";
import Billing from "./pages/Billing";
import NewInvoice from "./pages/NewInvoice";
import Invoices from "./pages/Invoices";
import Settings from "./pages/Settings";
import InvoiceView from "./pages/InvoiceView";
import { Toaster } from "react-hot-toast";
import EditInvoice from "./pages/EditInvoice";
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
import { fetchCsrfToken } from "./api/auth";
import BillingSuccess from "./pages/BillingSuccess";
import SessionExpiredModal from "./components/SessionExpiredModal";
import ProfileGuard from "./components/ProfileGuard";
import PlanGuard from "./components/PlanGuard";
import UpdatePlan from "./pages/UpdatePlan"
import LandingPage from "./pages/LandingPage";
import CommingSoon from "./pages/CommingSoon";
import MainPage from "./pages/MainPage";
import SplashScreen from "./components/SplashScreen";



// Redirect to /welcome if already logged in
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  // if (loading) return null;
  if (loading) {
  return <SplashScreen />;
  }
  return user ? <Navigate to="/welcome" replace /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PublicRoute>
            <MainPage />
          </PublicRoute>
        }
      />
      {/* <Route
        path="/"
        element={
          <PublicRoute>
            <CommingSoon />
          </PublicRoute>
        }
      />
       <Route
        path="/landingPage"
        element={
          <PublicRoute>
            <LandingPage />
          </PublicRoute>
        }
      /> */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
              <Route path="/invoice/:id" element={ <ProtectedRoute><InvoiceView /></ProtectedRoute>} />

      <Route
        path="/welcome"
        element={
          <ProtectedRoute>
            <WelcomePage />
          </ProtectedRoute>
        }
      />
      
       <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <ProfileGuard>
            <Dashboard />
            </ProfileGuard>
          </ProtectedRoute>
        }
      />
       <Route
        path="/invoice/ai"
        element={
          <ProtectedRoute>
             <ProfileGuard>
               <PlanGuard>
              <AIGenerate/> 
               </PlanGuard>
            </ProfileGuard>
          </ProtectedRoute>
        }
      />
      <Route path="/update-plan" 
      element={<ProtectedRoute>
             <ProfileGuard>
              <UpdatePlan />
              </ProfileGuard>
              </ProtectedRoute>
            } 
            />
       <Route
        path="/billing"
        element={
          <ProtectedRoute>
             <ProfileGuard>
            <Billing />
            </ProfileGuard>
          </ProtectedRoute>
        }
      />
      <Route
  path="/billing/success" 
  element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>}
/>
      <Route path="/invoice/new" element={ <ProtectedRoute> <ProfileGuard><NewInvoice /> </ProfileGuard></ProtectedRoute>} />
      <Route path="/invoices" element={<ProtectedRoute> <ProfileGuard><Invoices /> </ProfileGuard></ProtectedRoute>} />
      <Route path="/invoice/edit/:id" element={<ProtectedRoute><EditInvoice /></ProtectedRoute>} />
<Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
    const [ready, setReady] = useState(false);
    const [sessionExpired, setSessionExpired] = useState(false);

useEffect(() => {
  const handleSessionExpired = () => {
      console.log("SESSION EVENT RECEIVED");

    setSessionExpired(true);
  };

  window.addEventListener(
    "session-expired",
    handleSessionExpired
  );

  return () => {
    window.removeEventListener(
      "session-expired",
      handleSessionExpired
    );
  };
}, []);

//  useEffect(() => {
//     const init = async () => {
//       try {
//         await fetchCsrfToken();
//       } catch (err) {
//         console.error("CSRF init failed", err);
//       } finally {
//         setReady(true);
//       }
//     };

//     init();
//   }, []);
useEffect(() => {
  const init = async () => {
    console.log("INIT START");
    const t0 = Date.now();

    try {
      await fetchCsrfToken();
    } finally {
      console.log("INIT END:", Date.now() - t0);
      setReady(true);
    }
  };

  init();
}, []);
const handleLoginRedirect = () => {
  localStorage.clear();
  sessionStorage.clear();

  setSessionExpired(false);

  window.location.href = "/";
};
  if (!ready) {
     return <SplashScreen />;
}

  // if(!ready){
  //     return (
  //   <div
  //     style={{
  //       minHeight: "100vh",
  //       display: "grid",
  //       placeItems: "center",
  //       background: "#0c0c0f",
  //       color: "white",
  //       fontFamily: "sans-serif",
  //     }}
  //   >
  //     Loading...
  //   </div>
  // );
  // }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" />
          <SessionExpiredModal
    open={sessionExpired}
    onLogin={handleLoginRedirect}
  />

          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}
